export let hres6buColumns = () => {
  let indexColumns = [
    {
      key: 'codempid',
      name: '',
      labelCodapp: 'HRES6BUC1',
      labelIndex: '30',
      class: 'align-center',
      style: 'min-width: 100px;'
    }, {
      key: 'desc_codempid',
      name: '',
      labelCodapp: 'HRES6BUC1',
      labelIndex: '40',
      style: 'min-width: 200px;'
    }, {
      key: 'dtereq',
      name: '',
      labelCodapp: 'HRES6BUC1',
      labelIndex: '50',
      class: 'align-center',
      style: 'min-width: 120px;',
      dataType: 'date'
    }, {
      key: 'dtework',
      name: '',
      labelCodapp: 'HRES6BUC1',
      labelIndex: '60',
      class: 'align-center',
      style: 'min-width: 120px;',
      dataType: 'date'
    }, {
      key: 'codshift',
      name: '',
      labelCodapp: 'HRES6BUC1',
      labelIndex: '70',
      class: 'align-center',
      style: 'min-width: 100px;'
    }, {
      key: 'timin',
      name: '',
      labelCodapp: 'HRES6BUC1',
      labelIndex: '80',
      class: 'align-center',
      style: 'min-width: 350px;',
      headerRow: 1,
      colspan: 2,
      rowspan: 1
    }, {
      key: 'timin_o',
      name: '',
      labelCodapp: 'HRES6BUC1',
      labelIndex: '90',
      class: 'align-center',
      headerRow: 2,
      colspan: 1,
      rowspan: 1
    }, {
      key: 'timin_n',
      name: '',
      labelCodapp: 'HRES6BUC1',
      labelIndex: '100',
      class: 'align-center',
      headerRow: 2,
      colspan: 1,
      rowspan: 1
    }, {
      key: 'remark',
      name: '',
      labelCodapp: 'HRES6BUC3',
      labelIndex: '160',
      style: 'min-width: 200px;'
    }, {
      key: 'reason',
      name: '',
      labelCodapp: 'HRES6BUC1',
      labelIndex: '110',
      style: 'min-width: 200px;'
    }, {
      key: 'status',
      name: '',
      labelCodapp: 'HRES6BUC1',
      labelIndex: '120',
      style: 'min-width: 200px;'
    }, {
      key: 'desc_codappr',
      name: '',
      labelCodapp: 'HRES6BUC1',
      labelIndex: '130',
      style: 'min-width: 200px;'
    }, {
      key: 'dteappr',
      name: '',
      labelCodapp: 'HRES6BUC1',
      labelIndex: '140',
      class: 'align-center',
      style: 'min-width: 120px;',
      dataType: 'date'
    }, {
      key: 'remarkap',
      name: '',
      labelCodapp: 'HRES6BUC1',
      labelIndex: '150',
      style: 'min-width: 200px;'
    }, {
      key: 'desc_codempap',
      name: '',
      labelCodapp: 'HRES6BUC1',
      labelIndex: '160',
      style: 'min-width: 200px;'
    }
  ]

  let tab2TableColumns = [
    {
      key: 'dtework',
      name: '',
      labelCodapp: 'HRES6BUC4',
      labelIndex: '30',
      class: 'align-center',
      style: 'min-width: 120px;',
      dataType: 'date'
    }, {
      key: 'typwork',
      name: '',
      labelCodapp: 'HRES6BUC4',
      labelIndex: '40',
      class: 'align-center',
      style: 'min-width: 100px;'
    }, {
      key: 'codshift',
      name: '',
      labelCodapp: 'HRES6BUC4',
      labelIndex: '50',
      class: 'align-center',
      style: 'min-width: 100px;'
    }, {
      key: 'timework',
      name: '',
      labelCodapp: 'HRES6BUC4',
      labelIndex: '60',
      class: 'align-center',
      style: 'min-width: 100px;'
    }, {
      key: 'dtein',
      name: '',
      labelCodapp: 'HRES6BUC4',
      labelIndex: '70',
      class: 'align-center',
      style: 'min-width: 120px;',
      dataType: 'datetime'
    }, {
      key: 'dteout',
      name: '',
      labelCodapp: 'HRES6BUC4',
      labelIndex: '80',
      class: 'align-center',
      style: 'min-width: 120px;',
      dataType: 'datetime'
    }
  ]

  return {
    en: {
      index: indexColumns,
      detailTab2: tab2TableColumns
    },
    th: {
      index: indexColumns,
      detailTab2: tab2TableColumns
    }
  }
}

export let hres6buMaxRowspan = {
  index: 2
}



// WEBPACK FOOTER //
// ./src/assets/columns/hres6bu.js